// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"71":"atk-vue-multiline","376":"vendor-vue-query-builder","477":"atk-vue-inline-edit","507":"atk-vue-tree-item-selector","528":"vendor-vue-flatpickr","590":"atk-vue-item-search","662":"atk-vue-query-builder","736":"vendor"}[chunkId] + ".min.js";
};